(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["beamford-purchase-notes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('beamford-purchase-notes')) {
customElements.define('beamford-purchase-notes', class extends HTMLElement {
connectedCallback() {
this.section = this.closest('.shopify-section');
this.onProduct = (event) => {
if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
event.promise?.then((result) => {
const selector = 'beamford-purchase-notes[data-block-id="' + this.dataset.blockId + '"] [data-ship]';
const fresh = result?.detail?.html?.querySelector(selector);
const ship = this.querySelector('[data-ship]');
if (fresh && ship) ship.textContent = fresh.textContent;
}).catch(() => {});
};
this.section?.addEventListener('shopify:product:select', this.onProduct);
}
disconnectedCallback() {
this.section?.removeEventListener('shopify:product:select', this.onProduct);
}
});
}
  } catch(e) { console.error(e); }
})();

})();
